import { QdzElement, define } from '@qdz/element';

const HOVER = window.matchMedia('(hover: hover) and (pointer: fine)');

export class QdzProductCard extends QdzElement {
  #resting = null;

  get image() {
    return this.querySelector('.qdz-card__image:not(.qdz-card__image--second)');
  }

  mount() {
    this.listen(this, 'click', (event) => {
      const swatch = event.target.closest('.qdz-card__swatch-button');
      if (swatch && this.contains(swatch)) this.select(swatch);
      const step = event.target.closest('[data-step]');
      if (step && this.contains(step)) this.step(Number(step.dataset.step));
    });
    const list = this.querySelector('.qdz-card__swatches');
    const mode = list?.dataset.hover ?? 'click';
    if (!list || mode === 'click') return;
    this.listen(list, 'pointerover', (event) => {
      const swatch = event.target.closest('.qdz-card__swatch-button');
      if (!swatch || !HOVER.matches) return;
      if (mode === 'select') this.select(swatch);
      else this.#preview(swatch);
    });
    this.listen(list, 'pointerleave', () => this.#restore());
  }

  select(swatch) {
    for (const button of this.querySelectorAll('.qdz-card__swatch-button')) {
      button.setAttribute('aria-pressed', String(button === swatch));
    }
    this.#resting = null;
    this.#apply(swatch);
    this.classList.add('qdz-card--picked');
  }

  #preview(swatch) {
    const image = this.image;
    if (!image || !swatch.dataset.srcset) return;
    this.#resting ??= { srcset: image.getAttribute('srcset'), src: image.getAttribute('src') };
    image.srcset = swatch.dataset.srcset;
    image.src = swatch.dataset.srcset.split(' ')[0];
  }

  #restore() {
    const image = this.image;
    if (!image || !this.#resting) return;
    if (this.#resting.srcset === null) image.removeAttribute('srcset');
    else image.srcset = this.#resting.srcset;
    if (this.#resting.src) image.src = this.#resting.src;
    this.#resting = null;
  }

  step(direction) {
    const dots = [...this.querySelectorAll('.qdz-showcase__dot')];
    if (dots.length < 2) return;
    const current = Math.max(0, dots.findIndex((dot) => dot.hasAttribute('data-current')));
    const next = dots[(current + direction + dots.length) % dots.length];
    dots.forEach((dot) => dot.toggleAttribute('data-current', dot === next));
    this.#apply(next);
  }

  #apply(source) {
    const image = this.image;
    if (image && source.dataset.srcset) {
      image.srcset = source.dataset.srcset;
      image.src = source.dataset.srcset.split(' ')[0];
    }
    if (source.dataset.url) {
      for (const link of this.querySelectorAll('.qdz-card__link, .qdz-card__media-link')) link.href = source.dataset.url;
    }
  }
}

define('qdz-product-card', QdzProductCard);
